import React, { useState, useEffect } from 'react'
import { Input, Button, Card, Modal, Form, message } from 'antd'
import { paginationInit, initCurryingObj, formatMessage } from '@/utils/common'
import { modalConfirm } from '@/utils/modalUtils'
import { configSave, configQuery, batchSave } from '@/services/configuration/config'
import { PlusOutlined } from '@ant-design/icons'
import AntdTable from '@/components/table/AntdTable'
import { CONFIG_STATUS } from '@/utils/types'
import { useSelector } from 'react-redux'
import { hasPermission } from '@/annotations/nike-react'

const statusObj = initCurryingObj(CONFIG_STATUS)
const menu_nfc_configuration_channel = 'menu_nfc_configuration_channel'
const ChannelPage = () => {
  const commonStore = useSelector(state => state.commonStore)
  const [newModalForm] = Form.useForm()
  const [tableList, setTableList] = useState([])
  const [queryFlag, setQueryFlag] = useState(false)
  const [statusFlag, setStatusFlag] = useState(false)
  const [pagination, setPagination] = useState(paginationInit)
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [visibleFlag, setVisibleFlag] = useState(false)

  const tableColumns = [
    {
      title: formatMessage(commonStore, 'languageObj.configuration.channel'),
      dataIndex: 'configValue'
    },
    {
      title: formatMessage(commonStore, 'languageObj.commonLocale.status'),
      dataIndex: 'configStatus',
      render: text => statusObj[text]
    }
  ]

  useEffect(() => {
    searchDataFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryFlag])

  useEffect(() => {
    if (selectedRowKeys.length === 0 && statusFlag) setStatusFlag(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRowKeys])

  const handleTableChange = pagina => {
    const params = {
      ...pagination,
      currentPage: pagina.current,
      pageSize: pagina.pageSize
    }
    setPagination({ ...params })
    setQueryFlag(!queryFlag)
  }
  const searchDataFun = () => {
    const params = {
      configKey: 'channel',
      configStatus: '',
      configType: 'channel_config',
      // "configValue": "string",
      // "id": 0,
      // pageNo: 1,
      // size: 10,
      // total: 0
      pageNo: pagination.currentPage,
      size: pagination.pageSize,
      total: pagination.total
    }
    configQuery(params).then(res => {
      const dt = res.resultData
      setTableList(dt.records)
      const pg = {
        ...pagination,
        total: dt.total
      }
      setPagination(pg)
    })
  }
  const updateDataStatus = () => {
    modalConfirm(
      {
        content: statusFlag
          ? formatMessage(commonStore, 'languageObj.configuration.enableDataTip')
          : formatMessage(commonStore, 'languageObj.configuration.disableDataTip')
      },
      () => {
        const params = []
        for (let index = 0; index < tableList.length; index++) {
          const element = tableList[index]
          if (selectedRowKeys.indexOf(element.id) !== -1) {
            params.push({
              configKey: 'channel',
              configStatus: statusFlag,
              configType: 'channel_config',
              configValue: element.configValue,
              isAdd: false
            })
          }
        }
        batchSave(params).then(res => {
          if (res.errorCode === '200') {
            message.success(formatMessage(commonStore, 'languageObj.commonLocale.success'))
            setSelectedRowKeys([])
            setQueryFlag(!queryFlag)
          }
        })
      }
    )
  }
  const handleUserOk = () => {
    const values = newModalForm.getFieldsValue()
    if (values.channel?.length === 0 || values.channel === undefined || values.channel === null) return
    const params = {
      configKey: 'channel',
      configStatus: true,
      configType: 'channel_config',
      configValue: values.channel,
      // "id": selectedRowKeys,
      isAdd: true
    }
    configSave(params).then(res => {
      if (res.errorCode === '200') {
        message.success(formatMessage(commonStore, 'languageObj.commonLocale.success'))
        setQueryFlag(!queryFlag)
        setVisibleFlag(false)
      }
    })
  }
  const handleUserCancel = () => {
    setVisibleFlag(false)
  }
  const onSelectChange = newSelectedRowKeys => {
    const matchedObjects = tableList.filter(item => newSelectedRowKeys.includes(item.id))
    const allFalse = matchedObjects.every(item => item.configStatus === false)
    setStatusFlag(allFalse)
    setSelectedRowKeys(newSelectedRowKeys)
  }
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange
  }
  const hasSelected = selectedRowKeys.length > 0
  return (
    <div>
      <Card bordered={false} bodyStyle={{ padding: 4 }}>
        {hasPermission(menu_nfc_configuration_channel) && (
          <>
            <Button
              type="primary"
              style={{ marginLeft: '16px', marginTop: '10px' }}
              onClick={() => {
                setVisibleFlag(true)
              }}
            >
              <PlusOutlined />
              {formatMessage(commonStore, 'languageObj.configuration.addChannel')}
            </Button>
            <Button
              type="primary"
              danger={!statusFlag}
              disabled={!hasSelected}
              style={{ marginLeft: '20px', marginTop: '10px' }}
              onClick={() => {
                updateDataStatus()
              }}
            >
              {statusFlag
                ? formatMessage(commonStore, 'languageObj.configuration.enable')
                : formatMessage(commonStore, 'languageObj.configuration.disable')}
            </Button>
          </>
        )}
        <div className="content-container">
          <AntdTable
            rowKey={record => record.id}
            dataSource={tableList}
            columns={tableColumns}
            pagination={pagination}
            onChange={handleTableChange}
            rowSelection={hasPermission(menu_nfc_configuration_channel) && rowSelection}
          />
        </div>
      </Card>
      <Modal
        open={visibleFlag}
        maskClosable={false}
        className="nike_modal"
        width={400}
        title={formatMessage(commonStore, 'languageObj.configuration.addChannel')}
        onOk={handleUserOk}
        onCancel={handleUserCancel}
        destroyOnClose
      >
        <Form
          name="basic"
          form={newModalForm}
          labelCol={{
            span: 6
          }}
          wrapperCol={{
            span: 18
          }}
          style={{
            maxWidth: 400
          }}
          initialValues={{}}
          autoComplete="off"
        >
          <Form.Item label={formatMessage(commonStore, 'languageObj.configuration.channel')} name="channel">
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  )
}
export default ChannelPage
